/* eslint-disable */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { verticalList } from "../../homePage/model/HomePage";
import { RelatedVideo, Video } from "../../../stores/program/model/Program";
import ProgramDetail from "../modal/ProgramDetail";
import { resetfilter } from "../../video/VideoFilterActions";
import { changeMenu } from "../../../root/components/layout/header/HeaderActions";
import styles from "./verticalList.module.css";
import {
  CardContent,
  CardActionArea,
  CardMedia,
  Avatar,
  Modal,
  makeStyles,
  createStyles,
  Theme,
} from "@material-ui/core";
import PuiTypography from "../../../components/elements/PuiTypography";
import PuiTooltip from "../../../components/elements/PuiTooltip ";
import NewIcon from "../images/NewIcon";
import useResponsive from "../../../common/useResponsive";

interface VerticalListProps {
  // リスト名
  id: string;
  /* リストタイトル */
  title: string;
  /* リスト内容title,remark,image */
  itemList: verticalList[];
  /* 画像の形 */
  imageShape: "circular" | "rounded" | "square";
  /* リンク名 */
  linkName: string;
  /* リンクURL */
  linkUrl: string;
}

const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    cardActionArea: {
      backgroundColor: "white",
      borderRadius: "6px",
      marginBottom: "8px",
      boxShadow: "0 3px 3px lightgrey",
    },
    avatar: {
      width: "100%",
      height: "100%",
      borderRadius: "6px 0 0 6px",
      objectFit: "cover",
      backgroundColor: "white",
    },
    avatarUser: {
      width: "85px",
      height: "85px",
      borderRadius: "50%",
      objectFit: "cover",
      marginLeft: "auto",
      marginRight: "auto",
      backgroundColor: "white",
    },
  })
);

export default function VerticalList({ ...props }: VerticalListProps) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useNavigate();
  const { isDesktop } = useResponsive();

  const [programTitle, ChangeProgramTitle] = useState("");
  const [programDetail, ChangeProgramDetail] = useState("");
  const [programEpisode, ChangeProgramEpisode] = useState<Video[]>([]);
  const [programRelated, ChangeProgramRelated] = useState<RelatedVideo[]>([]);
  const [programSelected, ChangeProgramSelected] = useState<Video>();

  // プログラム詳細モーダルの表示用
  const [isOpenProgramModal, ShowProgramModal] = useState(false);
  const OpenProgramModal = () => {
    ShowProgramModal(true);
  };
  const CloseProgramModal = () => {
    ShowProgramModal(false);
    ChangeProgramTitle("");
    ChangeProgramDetail("");
    ChangeProgramEpisode([]);
    ChangeProgramRelated([]);
    // ChangeProgramSelected();
  };

  // 各リンク押下
  const ClickLink = () => {
    console.log("ClickLink start");
    switch (props.id) {
      // 新着ビデオ
      case "newVideos":
        dispatch(
          resetfilter({
            id: [],
            professional: [],
            program: [],
            project: [],
            tag: [],
          })
        );
        dispatch(changeMenu("/homepage", "/videos", "right"));
        history(props.linkUrl);
        break;

      // おすすめプログラム
      // おすすめプロフェッショナル
      case "recommendPrograms":
      case "recommendProfessionals":
        history(props.linkUrl);
        break;
      default:
        break;
    }
  };

  // 各リスト項目押下
  const ClickListItem = (itemId: string, name: string,videoHash:string) => {
    console.log("ClickListItem start", itemId);
    switch (props.id) {
      // 新着ビデオ
      case "newVideos":
        history("/video/" + videoHash);
        break;

      // おすすめプログラム
      case "recommendPrograms":
        console.log("test:", props.itemList);
        for (let i = 0; i < props.itemList.length; i++) {
          const element = props.itemList[i];
          if (element.id === itemId) {
            ChangeProgramTitle(element.title);
            if (element.description) ChangeProgramDetail(element.description);
            if (element.videos) {
              ChangeProgramEpisode(element.videos);
              // フォーカスビデオをセット
              const selectedOne = selectVideo(element.videos);
              console.log(selectedOne);
              ChangeProgramSelected(selectedOne);
            }
            if (element.relatedVideos)
              ChangeProgramRelated(element.relatedVideos);
          }
        }
        // ChangeProgramTitle(props.itemList[Number(props.itemList.findIndex(({id}) => id === itemId))].title);
        // ChangeProgramDetail(props.itemList[Number(props.itemList.findIndex(({id}) => id === itemId))].description);
        // ChangeProgramEpisode(props.itemList[Number(props.itemList.findIndex(({id}) => id === itemId))].videos);
        // ChangeProgramRelated(props.itemList[Number(props.itemList.findIndex(({id}) => id === itemId))].relatedVideos);
        // フォーカスビデオをセット
        // const selectedOne = selectVideo(props.itemList[Number(props.itemList.findIndex(({id}) => id === itemId))].videos)
        // ChangeProgramSelected(selectedOne);
        // ChangeProgramSelected(programList[Number(programList.findIndex(({id}) => id === itemId))].videos[0]);
        OpenProgramModal();
        break;

      // おすすめプロフェッショナル
      case "recommendProfessionals": {
        // 該当プロフェッショナルでストア絞り込み、ビデオ画面の表示セット
        const professionalFilter = {
          id: itemId === "" ? [] : [itemId],
          professional: name === "" ? [] : [name],
          program: [],
          project: [],
          tag: [],
        };
        dispatch(resetfilter(professionalFilter));
        dispatch(changeMenu("/homepage", "/videos", "right"));
        history("/videos");
        break;
      }
      default:
        break;
    }
  };

  // フォーカスされたビデオを決める
  const selectVideo = (videos: Video[]) => {
    if (videos.length === 1) {
      return videos[0];
    }
    if (videos.length > 1) {
      // 最新履歴の日付をとる（時間）
      const latestDate = Math.max(
        ...videos.map((item) => {
          if (item.viewingActivities.length > 0) {
            return Date.parse(item.viewingActivities[0].created);
          } else {
            return -1;
          }
        })
      );
      // console.log(latestDate)
      if (latestDate === -1) return videos[0];
      for (let j = 0; j < videos.length; j++) {
        // 視聴していないビデオをスキップ
        if (videos[j].viewingActivities.length === 0) continue;
        const date = Date.parse(videos[j].viewingActivities[0].created);
        const isFinished = videos[j].viewingActivities[0].isFinished;
        // console.log("condition: ", date, isFinished)
        if (date === latestDate && !isFinished) {
          const latest = videos[j];
          return latest;
        } else if (date === latestDate && isFinished) {
          const index = j;
          if (index === videos.length - 1) return videos[0];
          const next = videos[j + 1];
          return next;
        }
      }
    }
  };

  return (
    <div className={styles.card}>
      {/* リストタイトル */}
      <div className={styles.listTitle}>
        <PuiTypography size={isDesktop ? 24 : 16} bold={true}>
          {props.title}
        </PuiTypography>
        <div className={styles.link} onClick={ClickLink}>
          <PuiTypography size={isDesktop ? 16 : 14} color="gray-61">
            {props.linkName}
          </PuiTypography>
        </div>
      </div>

      {/* リスト内容 */}
      {props.itemList.length > 0 && (
        <div className={styles.listDetail}>
          {props.itemList.map((row) => (
            <CardActionArea
              key={row.title}
              className={classes.cardActionArea}
              onClick={() => ClickListItem(row.id, row.title,row.hash)}
            >
              <CardContent
                key={row.title}
                className={styles.listItem}
                style={{ padding: "0px" }}
              >
                <CardMedia className={styles.image}>
                  {(row.visibleNewIcon ||
                    (props.id === "recommendPrograms" &&
                      row.videos &&
                      row.videos.filter((v) => v.visibleNewIcon === true)
                        .length > 0)) && (
                    <div className={styles.newIcon}>
                      <NewIcon />
                    </div>
                  )}
                  <div className={styles.avatarDiv}>
                    {(props.id === "newVideos" ||
                      props.id === "recommendProfessionals") && (
                      <Avatar
                        src={row.imageUrl}
                        variant={props.imageShape}
                        className={
                          props.id === "recommendProfessionals"
                            ? classes.avatarUser
                            : classes.avatar
                        }
                      />
                    )}
                    {/* {row.showImageUrl} */}
                    {props.id === "recommendPrograms" && (
                      <Avatar
                        src={row.showImageUrl}
                        variant={props.imageShape}
                        className={classes.avatar}
                      />
                    )}
                  </div>
                </CardMedia>
                <div className={styles.listText}>
                  <div
                    className={styles.itemName}
                    data-tip={row.title}
                    data-for="itemName"
                  >
                    <PuiTypography size={isDesktop ? 20 : 16} bold={true} rows={2}>
                      {row.title}
                    </PuiTypography>
                    <PuiTooltip id={"itemName"} />
                  </div>
                  {props.id === "newVideos" &&
                    row.professional !== undefined && (
                      <div className={styles.remark}>
                        <PuiTypography
                          size={16}
                        >{`Presenter: ${row.professional}`}</PuiTypography>
                      </div>
                    )}
                  {(props.id === "recommendPrograms" ||
                    props.id === "recommendProfessionals") &&
                    row.sub !== undefined && (
                      <div className={styles.remark}>
                        <PuiTypography size={16}>{row.sub}</PuiTypography>
                      </div>
                    )}
                </div>
              </CardContent>
            </CardActionArea>
          ))}
        </div>
      )}

      {/* プログラム詳細画面モーダル */}
      {props.id === "recommendPrograms" && (
        <Modal
          aria-labelledby="programDetail"
          aria-describedby="programDetail"
          className={styles.modal}
          open={isOpenProgramModal}
          onClose={CloseProgramModal}
          closeAfterTransition
        >
          <ProgramDetail
            in={isOpenProgramModal}
            title={programTitle}
            description={programDetail}
            episodelist={programEpisode}
            related={programRelated}
            selected={programSelected}
          />
        </Modal>
      )}
    </div>
  );
}
